import {ROUTES} from "../constants";
import {apiRequest} from "./api.client";
import {PrescriptionResponse} from "./diagnosis.service";

export type DeliveryChannel = "email" | "whatsapp";
export type DeliveryStatus = "pending" | "sent" | "failed";

export interface DeliveryRecord{
    id: string;
    prescription_id: string;
    channel: DeliveryChannel | string;
    status: DeliveryStatus | string;
    sent_at?: string;
    recipient?: string;
    error_reason?: string;
    created_at: string;
}

export interface DeliveryStatusResponse{
    prescription_id: string;
    records: DeliveryRecord[];
}

export const PrescriptionDeliveryAPI={
    finalise(prescriptionId: string): Promise<PrescriptionResponse>{
        return apiRequest<PrescriptionResponse>(
            ROUTES.PRESCRIPTION_FINALISE(prescriptionId),
            {method: "POST"},
        );
    },
    sendEmail(prescriptionId: string): Promise<DeliveryRecord>{
        return apiRequest<DeliveryRecord>(
            ROUTES.PRESCRIPTION_SEND_EMAIL(prescriptionId),
            {method: "POST"},
        );
    },
    sendWhatsapp(prescriptionId: string): Promise<DeliveryRecord>{
        return apiRequest<DeliveryRecord>(
            ROUTES.PRESCRIPTION_SEND_WHATSAPP(prescriptionId),
            {method: "POST"},
        );
    },
    getDeliveryStatus(prescriptionId: string): Promise<DeliveryStatusResponse>{
        return apiRequest<DeliveryStatusResponse>(
            ROUTES.PRESCRIPTION_DELIVERY_STATUS(prescriptionId),
        );
    },
};
